import React, { useEffect, useState } from "react";
import { BiHistory, BiSolidPencil, BiSolidUser } from "react-icons/bi";
import { AiFillLock, AiFillSave } from "react-icons/ai";
import { CiMobile3, CiMail } from "react-icons/ci";
import { GoLocation } from "react-icons/go";
import { BiSolidCity } from "react-icons/bi";
import { PiWalletBold, PiBankDuotone } from "react-icons/pi";
import { AiFillSetting } from "react-icons/ai";
import { RxCross1 } from "react-icons/rx";
import { GoCreditCard } from "react-icons/go";
import { IoLockClosedOutline } from "react-icons/io5";
import { Link } from "react-router-dom";
import { BsPlusLg } from "react-icons/bs";
import { HiDocumentDownload } from "react-icons/hi";
import {
  Button,
  DatePicker,
  Input,
  InputNumber,
  Popover,
  Radio,
  Spin,
  notification,
} from "antd";
import profile from "../../../assests/icons/Oval.png";
import handleGet from "../../../utils/Get";
import { BASE_URL } from "../../../utils/config";
import handlePost from "../../../utils/Post";
import { useDispatch } from "react-redux";
import { changeHeader } from "../../../redux/reducer/headerSlice";
import { UserUpdate } from "../../../redux/reducer/userSlice";
import payment from "../../../assests/images/payment_image.png";
import dayjs from "dayjs";
import { useTranslation } from "react-i18next";

const { TextArea } = Input;

/* ─── Nav items ───────────────────────────────────────── */
const NAV_ITEMS = [
  { key: "first", icon: BiSolidUser, label: "General" },
  { key: "second", icon: PiWalletBold, label: "Payment" },
  { key: "third", icon: AiFillLock, label: "Verification" },
  { key: "fourth", icon: AiFillSetting, label: "Password" },
  { key: "fifth", icon: BiHistory, label: "History" },
];


/* ─── Shared atoms ───────────────────────────────────── */
const Field = ({ label, children }) => (
  <div className="mb-4">
    <label className="block text-xs font-semibold text-[#8B8FA8] uppercase tracking-widest mb-1.5">
      {label}
    </label>
    {children}
  </div>
);

const Badge = ({ status }) => {
  const map = {
    approved: "bg-emerald-500/10 text-emerald-400 border-emerald-500/30",
    declined: "bg-red-500/10 text-red-400 border-red-500/30",
    pending: "bg-amber-500/10 text-amber-400 border-amber-500/30",
    active: "bg-sky-500/10 text-sky-400 border-sky-500/30",
  };
  const cls = map[(status || "pending").toLowerCase()] || map.pending;
  return (
    <span className={`inline-flex items-center gap-1 px-2.5 py-0.5 rounded-full text-xs font-semibold border ${cls}`}>
      <span className="w-1.5 h-1.5 rounded-full bg-current" />
      {status || "Pending"}
    </span>
  );
};

const GlowBtn = ({ children, onClick, loading, variant = "primary", className = "", type = "button" }) => {
  const base = "inline-flex items-center gap-2 px-4 py-2 sm:px-5 sm:py-2.5 rounded-lg text-sm font-semibold transition-all duration-200 disabled:opacity-40";
  const variants = {
    primary: "bg-[#6C5DD3] hover:bg-[#7B6AE0] text-white shadow-[0_0_20px_rgba(108,93,211,0.3)] hover:shadow-[0_0_30px_rgba(108,93,211,0.5)]",
    success: "bg-[#0D1A12] border border-emerald-500/40 hover:border-emerald-500/70 text-emerald-400 hover:text-emerald-300",
    ghost: "bg-[#161826] border border-[#2A2D3E] hover:border-[#6C5DD3]/50 text-[#8B8FA8] hover:text-white",
    danger: "bg-[#1A0D0D] border border-red-500/40 hover:border-red-500/70 text-red-400 hover:text-red-300",
  };
  return (
    <button type={type} onClick={onClick} disabled={loading} className={`${base} ${variants[variant]} ${className}`}>
      {loading ? <span className="w-4 h-4 border-2 border-current border-t-transparent rounded-full animate-spin" /> : children}
    </button>
  );
};

const darkInputStyle = { borderColor: "#2A2D3E", color: "#fff", borderRadius: "8px" };

/* ══════════════════════════════════════════════════════ */
const UserProfile = () => {
  const avatar1 = `${window.location.origin}/avatar1.png`;
  const avatar2 = `${window.location.origin}/avatar2.jpg`;
  const avatar3 = `${window.location.origin}/avatar3.jpg`;
  const avatar4 = `${window.location.origin}/avatar4.png`;
  const avatar5 = `${window.location.origin}/avatar5.jpg`;
  const avatar6 = `${window.location.origin}/avater6.png`;

  const defaultAvatars = [
    { link: avatar1, id: 0 }, { link: avatar2, id: 1 }, { link: avatar3, id: 2 },
    { link: avatar4, id: 3 }, { link: avatar5, id: 4 }, { link: avatar6, id: 5 },
  ];

  const [activeTab, setActiveTab] = useState("first");
  // tabManage false = add payment screen (original logic)
  const [tabManage, setTabManage] = useState({ first: true, second: false, third: false, fourth: false, fifth: false });

  const [loading, setLoading] = useState({ general: false, payment: false, password: false });
  const [data, setData] = useState("");
  const [buttonManage, setButtonManage] = useState(true);
  const [radio, setRadio] = useState("bank");
  const [cardData, setCardData] = useState({ card_holder_name: "", card_number: "", card_expiry_month: dayjs().format("MM"), card_expiry_year: dayjs().format("YYYY"), card_cvv: "" });
  const [accountData, setAccountData] = useState({ acount_holder_name: "", bank_name: "", account_number: "", bank: "swift" });
  const [password, setPassword] = useState({ current_password: "", new_password: "", repeat_password: "" });
  const [paymentMethod, setPaymentMethod] = useState("");
  const [loginUser, setLoginUser] = useState([]);

  const user = JSON.parse(localStorage.getItem("user"));
  const { id } = JSON.parse(localStorage.getItem("user"));
  const dispatch = useDispatch();

  const { t } = useTranslation();
  const { recovery, Recovery, phrase, If, Phrase, and, keep, It, In, a, safe, place, This, way, recover, lose, cancel, save: saveTxt, Accountverification, Passwordchange, Loginhistory, Paymentmethods, information, general, Information, General, email, address, Address, userName, pass, Password, Phone, number, Number, City, city, country, Country, postal, code, write, down, your } = t("general", { returnObjects: true });
  const { login, browser, location, platform, ip, at, logout, status, history, Login, device } = t("loginhistory", { returnObjects: true });
  const { change, an, improved, security, account, repeat, current, Current, enter, New, settings, Settings, Repeat } = t("passwordchange", { returnObjects: true });

  const fetchPaymentMethod = async () => {
    try { const res = await handleGet(`${BASE_URL}get/user/payment-methods`); setPaymentMethod(res?.paymentMethods); }
    catch (e) { console.log(e); }
  };

  useEffect(() => {
    const fetchUser = async () => {
      const res = await handleGet(`${BASE_URL}get/user/detail/${id}`);
      if (res) { setData(res?.user); dispatch(UserUpdate(res?.user)); }
    };
    fetchUser();
    fetchPaymentMethod();
  }, [id]);

  useEffect(() => { dispatch(changeHeader(`${user.name}`)); }, [user]);

  useEffect(() => {
    handleGet(`${BASE_URL}active/user/loginhistory/${user?.id}`).then(r => setLoginUser(r?.data));
  }, []);

  

  const handleUpdateUser = async () => {
    setLoading({ ...loading, general: true });
    try {
      const formData = { name: data.name, email: data.email, "details[phone_number]": data?.detail?.phone_number, "details[address]": data?.detail?.address, "details[city]": data?.detail?.city, "details[country]": data?.detail?.country, "details[postal_code]": data?.detail?.postal_code, "details[note]": data?.detail?.note, avatar: data?.avatar };
      const response = await handlePost(`${BASE_URL}update/profile`, formData);
      if (response) { setData(response?.data?.user); localStorage.setItem("note", data?.detail?.note); dispatch(UserUpdate(response?.data?.user)); }
    } catch (e) { console.log(e); }
    finally { setLoading({ ...loading, general: false }); }
  };

  const handlePasswordUpdate = async () => {
    setLoading({ ...loading, password: true });
    try {
      if (password?.new_password !== password?.repeat_password) {
        return notification.error({ message: "Please make sure the new password and repeat new password fields match exactly" });
      }
      await handlePost(`${BASE_URL}user/update/password`, password);
    } catch (e) { console.log(e); }
    finally { setLoading({ ...loading, password: false }); }
  };

  const handleAddPayment = async () => {
    setLoading({ ...loading, payment: true });
    try {
      if (radio === "card") {
        if (cardData?.card_cvv && cardData?.card_expiry_month && cardData?.card_expiry_year && cardData?.card_holder_name && cardData?.card_number) {
          const r = await handlePost(`${BASE_URL}store/user/payment-method`, { ...cardData, type: radio });
          if (r) fetchPaymentMethod();
        } else { notification.error({ message: "All Fields are required" }); }
      } else if (radio === "bank") {
        if (accountData?.account_number && accountData?.acount_holder_name && accountData?.bank_name) {
          const r = await handlePost(`${BASE_URL}store/user/payment-method`, { ...accountData, type: radio });
          if (r) fetchPaymentMethod();
        } else { notification.error({ message: "All Fields are required" }); }
      }
    } catch (e) { console.log(e); }
    finally { setLoading({ ...loading, payment: false }); }
  };

  /* ── Sync activeTab → tabManage for backward compat ── */
  const handleTabClick = (key) => {
    setActiveTab(key);
    setTabManage({ first: key === "first", second: key === "second", third: key === "third", fourth: key === "fourth", fifth: key === "fifth" });
  };

  const initials = (data?.name || "U").split(" ").map(n => n[0]).join("").toUpperCase().slice(0, 2);

  if (!data) return (
    <div className="min-h-screen bg-[#080A12] flex items-center justify-center">
      <div className="flex flex-col items-center gap-4">
        <div className="w-12 h-12 border-2 border-[#6C5DD3] border-t-transparent rounded-full animate-spin" />
        <p className="text-[#8B8FA8] text-sm">Loading profile...</p>
      </div>
    </div>
  );

  return (
    <div className="min-h-screen bg-[#080A12] p-3 sm:p-4 lg:p-6 font-sans">
      <div className="max-w-6xl mx-auto">

        {/* ── User header strip ── */}
        <div className="flex items-center gap-3 sm:gap-5 mb-4 sm:mb-6 lg:mb-8 p-3 sm:p-4 bg-[#0b1629] border border-[#1E2030] rounded-2xl">
          <div className="relative shrink-0">
            <div className="w-11 h-11 sm:w-16 sm:h-16 rounded-xl sm:rounded-2xl bg-gradient-to-br from-[#6C5DD3] to-[#9B8EE8] flex items-center justify-center text-white text-sm sm:text-xl font-bold shadow-[0_0_24px_rgba(108,93,211,0.4)] overflow-hidden">
              {data?.avatar_url
                ? <img src={data.avatar_url} className="w-full h-full object-cover" alt="avatar" />
                : initials}
            </div>
            <span className="absolute -bottom-0.5 -right-0.5 w-3 h-3 sm:w-4 sm:h-4 rounded-full bg-emerald-400 border-2 border-[#0D0F1A]" />
          </div>
          <div className="flex-1 min-w-0">
            <h1 className="text-sm sm:text-xl font-bold text-white truncate">{data?.name || "—"}</h1>
            <p className="text-xs sm:text-sm text-[#8B8FA8] truncate">{data?.email}</p>
          </div>
          <div className="shrink-0">
            <Badge status={user?.active_status || "pending"} />
          </div>
        </div>

        <div className="flex flex-col lg:flex-row gap-3 sm:gap-4 lg:gap-6">

          {/* ── Mobile/tablet horizontal tab bar ── */}
          <div className="lg:hidden">
            <div className="bg-[#0D0F1A] border border-[#1E2030] rounded-2xl p-1.5 flex gap-1 overflow-x-auto" style={{ scrollbarWidth: "none" }}>
              {NAV_ITEMS.map(({ key, icon: Icon, label }) => {
                const active = activeTab === key;
                return (
                  <button key={key} onClick={() => handleTabClick(key)}
                    className={`flex items-center gap-1.5 px-2 py-2 rounded-xl text-xs font-semibold whitespace-nowrap transition-all duration-200 shrink-0
                      ${active ? "bg-[#6C5DD3] text-white  shadow-[0_0_12px_rgba(108,93,211,0.3)]" : "text-[#8B8FA8] hover:bg-[#161826] hover:text-white"}`}>
                    <Icon size={13} /> {label}
                  </button>
                );
              })}
            </div>
          </div>

          {/* ── Desktop sidebar ── */}
          <aside className="hidden lg:block w-52 shrink-0">
            <nav className="bg-[#0D0F1A] border border-[#1E2030] rounded-2xl p-2 space-y-1">
              {NAV_ITEMS.map(({ key, icon: Icon, label }) => {
                const active = activeTab === key;
                return (
                  <button key={key} onClick={() => handleTabClick(key)}
                    className={`w-full flex items-center gap-3 px-3 py-2.5 rounded-xl text-sm font-medium transition-all duration-200 text-left group
                      ${active ? "bg-[#6C5DD3] text-white shadow-[0_0_16px_rgba(108,93,211,0.3)]" : "text-[#8B8FA8] hover:bg-[#161826] hover:text-white"}`}>
                    <Icon size={16} className={active ? "text-white" : "text-[#8B8FA8] group-hover:text-[#6C5DD3]"} />
                    <span className="text-xs tracking-wide">{label}</span>
                    {active && <span className="ml-auto w-1.5 h-1.5 rounded-full bg-white/60" />}
                  </button>
                );
              })}
            </nav>
          </aside>

          {/* ── Main panel ── */}
          <main className="flex-1 min-w-0 bg-[#0D0F1A] border border-[#1E2030] rounded-2xl p-4 sm:p-6 lg:p-8">

            {/* ══ GENERAL ══ */}
            {tabManage?.first && (
              <div>
                <div className="flex flex-wrap items-start justify-between mb-3 gap-3 border-b border-[#1E2030]">
                  <div>
                    <h2 className="text-base sm:text-lg font-bold text-white">{General} {Information}</h2>
                    <p className="text-xs text-[#8B8FA8] mt-0.5">Manage {your} {general} {information}</p>
                  </div>
                  <div className="flex items-center gap-2">
                    <GlowBtn loading={loading?.general} onClick={handleUpdateUser}><AiFillSave size={14} /> <span className="hidden sm:inline">{saveTxt}</span></GlowBtn>
                  </div>
                </div>

                {/* Avatar picker */}
                <div className="flex justify-center mb-6">
                  <div className="relative w-20 h-20 sm:w-24 sm:h-24">
                    <img
                      className="w-full h-full rounded-2xl border-2 border-[#6C5DD3] object-cover shadow-[0_0_20px_rgba(108,93,211,0.3)]"
                      src={data?.avatar_url ? data?.avatar_url : avatar1}
                      alt="avatar"
                    />
                    <Popover placement="bottom" content={() => (
                      <div className="flex gap-2 p-1">
                        <label className="w-10 h-10 rounded-full flex items-center justify-center bg-[#161826] border border-[#2A2D3E] cursor-pointer hover:border-[#6C5DD3]/50 transition-colors">
                          <input type="file" accept="image/*" className="hidden" onChange={e => { const file = e.target.files[0]; setData({ ...data, avatar: file }); }} />
                          <BiSolidPencil size={16} color="#8B8FA8" />
                        </label>
                        {defaultAvatars.map(({ link, id: aid }) => (
                          <img key={aid} onClick={() => setData({ ...data, avatar: link })} className={`w-10 h-10 rounded-full cursor-pointer transition-all ${data?.avatar === link ? "border-2 border-[#6C5DD3]" : "opacity-70 hover:opacity-100"}`} src={link} alt="avatar" />
                        ))}
                      </div>
                    )}>
                      <button className="absolute -bottom-1 -right-1 w-7 h-7 rounded-lg bg-[#6C5DD3] flex items-center justify-center shadow-lg hover:bg-[#7B6AE0] transition-colors">
                        <BiSolidPencil color="white" size={14} />
                      </button>
                    </Popover>
                  </div>
                </div>

                {/* Email */}
                <Field label={`${email} ${address}`}>
                  <Input readOnly name="email" value={data?.email} size="large" prefix={<CiMail className="text-[#8B8FA8]" />} style={{ ...darkInputStyle, opacity: 0.6 }} />
                </Field>

                {/* Name + Password row */}
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-5">
                  <Field label={userName}>
                    <Input onChange={e => setData({ ...data, name: e.target.value })} placeholder={userName} value={data?.name} size="large" style={darkInputStyle} />
                  </Field>
                  <Field label={Password}>
                    <Input.Password prefix={<IoLockClosedOutline className="text-[#8B8FA8]" />} disabled placeholder={pass} size="large" style={{ ...darkInputStyle, opacity: 0.6 }} />
                  </Field>
                </div>

                {/* Phone */}
                <Field label={`${Phone} ${number}`}>
                  <Input type="number" name="phone_number" onChange={e => setData({ ...data, detail: { ...data?.detail, phone_number: e.target.value } })} placeholder={Phone} value={data?.detail?.phone_number} prefix={<CiMobile3 className="text-[#8B8FA8]" />} size="large" style={darkInputStyle} />
                </Field>

                {/* Address + City */}
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-5">
                  <Field label={Address}>
                    <Input name="address" onChange={e => setData({ ...data, detail: { ...data?.detail, address: e.target.value } })} placeholder={address} prefix={<GoLocation className="text-[#8B8FA8]" />} value={data?.detail?.address} size="large" style={darkInputStyle} />
                  </Field>
                  <Field label={City}>
                    <Input name="city" onChange={e => setData({ ...data, detail: { ...data?.detail, city: e.target.value } })} placeholder={city} prefix={<BiSolidCity className="text-[#8B8FA8]" />} value={data?.detail?.city} size="large" style={darkInputStyle} />
                  </Field>
                  <Field label={Country}>
                    <Input name="country" onChange={e => setData({ ...data, detail: { ...data?.detail, country: e.target.value } })} placeholder={country} value={data?.detail?.country} size="large" style={darkInputStyle} />
                  </Field>
                  <Field label={`${postal} ${code}`}>
                    <Input name="postal_code" onChange={e => setData({ ...data, detail: { ...data?.detail, postal_code: e.target.value } })} placeholder={postal} value={data?.detail?.postal_code} size="large" style={darkInputStyle} />
                  </Field>
                </div>

                {/* Notes */}
                <Field label="Notes">
                  <TextArea readOnly name="note" value={data?.detail?.note} onChange={e => setData({ ...data, detail: { ...data?.detail, note: e.target.value } })} rows={4} style={{ ...darkInputStyle, resize: "none" }} />
                </Field>
              </div>
            )}

            {/* ══ PAYMENT METHODS LIST ══ */}
            {tabManage?.second && (
              <div>
                <div className="flex flex-wrap gap-3 items-start justify-between mb-2 border-b border-[#1E2030]">
                  <div>
                    <h2 className="text-base sm:text-lg font-bold text-white">{Paymentmethods || "Payment Methods"}</h2>
                    <p className="text-xs text-[#8B8FA8] mt-0.5">Manage your payment methods</p>
                  </div>
                  <GlowBtn onClick={() => setTabManage(false)}>
                    <BsPlusLg size={13} />
                    <span className="hidden sm:inline">Add New</span>
                  </GlowBtn>
                </div>

                {paymentMethod?.length ? (
                  <div className="space-y-2">
                    {paymentMethod.map((item) => (
                      <div key={item?.id} className="flex items-center gap-4 p-4 bg-[#080A12] border border-[#1E2030] rounded-xl hover:border-[#6C5DD3]/30 transition-colors">
                        <div className="w-11 h-11 rounded-xl bg-[#161826] border border-[#2A2D3E] flex items-center justify-center shrink-0">
                          {item?.type === "card"
                            ? <GoCreditCard size={20} className="text-[#6C5DD3]" />
                            : <PiBankDuotone size={20} className="text-[#6C5DD3]" />}
                        </div>
                        <div>
                          <p className="text-sm font-semibold text-white">
                            {item?.type === "card" ? item?.card_holder_name : item?.acount_holder_name}
                          </p>
                          <p className="text-xs text-[#8B8FA8]  mt-0.5">
                            {item?.type === "card"
                              ? `•••• •••• •••• ${item?.card_number?.slice(-4)}`
                              : `•••••••• ${item?.account_number?.slice(-4)}`}
                          </p>
                        </div>
                        <div className="ml-auto">
                          <span className="text-xs  px-2 py-1 rounded-lg bg-[#161826] border border-[#2A2D3E] text-[#8B8FA8] capitalize">{item?.type}</span>
                        </div>
                      </div>
                    ))}
                  </div>
                ) : (
                  <div className="flex flex-col items-center py-12">
                    <img className="w-full h-48 max-w-[280px] object-contain opacity-40" src={payment} alt="payment" />
                    <p className="text-base font-bold text-white mt-6">No payment methods found</p>
                    <p className="text-xs text-[#8B8FA8] mt-1 mb-6">Try adding a new payment method</p>
                    <GlowBtn onClick={() => setTabManage(false)}>
                      <BsPlusLg size={13} /> Add Payment Method
                    </GlowBtn>
                  </div>
                )}
              </div>
            )}

            {/* ══ ADD PAYMENT (tabManage === false) ══ */}
            {!tabManage && (
              <div>
                <div className="flex items-start justify-between mb-3 border-b border-[#1E2030]">
                  <div>
                    <h2 className="text-base sm:text-lg font-bold text-white">Add Payment Method</h2>
                    <p className="text-xs text-[#8B8FA8] mt-0.5">Choose a payment type below</p>
                  </div>
                  <div className="flex items-center gap-2">
                    <GlowBtn loading={loading?.payment} onClick={handleAddPayment}>
                      <AiFillSave size={14} /> Save
                    </GlowBtn>
                  </div>
                </div>

                {/* Radio type selector */}
                <div className="flex gap-2 mb-5">
                  {["bank", "card"].map(opt => (
                    <button key={opt} onClick={() => setRadio(opt)}
                      className={`flex items-center gap-2 px-4 py-2 rounded-xl text-sm font-semibold border transition-all
                        ${radio === opt ? "bg-[#6C5DD3] border-[#6C5DD3] text-white" : "bg-[#080A12] border-[#2A2D3E] text-[#8B8FA8] hover:border-[#6C5DD3]/40"}`}>
                      {opt === "bank" ? <PiBankDuotone size={16} /> : <GoCreditCard size={16} />}
                      {opt === "bank" ? "Bank Account" : "Credit Card"}
                    </button>
                  ))}
                </div>

                {radio === "card" ? (
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
                    <div className="space-y-0">
                      <Field label="Card Holder Name">
                        <Input value={cardData?.card_holder_name} onChange={e => setCardData({ ...cardData, card_holder_name: e.target.value })} size="large" placeholder="John Doe" style={darkInputStyle} />
                      </Field>
                      <Field label="Card Number">
                        <InputNumber className="w-full" type="number" value={cardData?.card_number} onChange={e => setCardData({ ...cardData, card_number: e })} size="large" placeholder="4242 4242 4242 4242" style={darkInputStyle} />
                      </Field>
                      <div className="grid grid-cols-3 gap-3">
                        <Field label="Exp. Month">
                          <DatePicker value={cardData?.card_expiry_month ? dayjs(cardData?.card_expiry_month) : dayjs()} onChange={(date, value) => setCardData({ ...cardData, card_expiry_month: value })} format="MM" allowClear={false} picker="month" suffixIcon={false} size="large" placeholder="MM" style={darkInputStyle} />
                        </Field>
                        <Field label="Exp. Year">
                          <DatePicker value={cardData?.card_expiry_year ? dayjs(cardData?.card_expiry_year) : dayjs()} format="YYYY" onChange={(date, value) => setCardData({ ...cardData, card_expiry_year: value })} allowClear={false} picker="year" suffixIcon={false} size="large" placeholder="YYYY" style={darkInputStyle} />
                        </Field>
                        <Field label="CVV">
                          <InputNumber onChange={e => setCardData({ ...cardData, card_cvv: e })} maxLength={3} type="number" size="large" placeholder="•••" style={darkInputStyle} />
                        </Field>
                      </div>
                    </div>

                    {/* Card preview */}
                    <div className="h-fit rounded-2xl p-5 bg-gradient-to-br from-[#1a1040] to-[#0d0820] border border-[#6C5DD3]/20 shadow-[0_0_30px_rgba(108,93,211,0.15)] relative overflow-hidden">
                      <div className="absolute top-0 right-0 -mt-4 -mr-4">
                        <div className="w-20 h-20 rounded-full bg-rose-500/20" />
                      </div>
                      <div className="absolute top-0 right-3">
                        <div className="w-14 h-14 rounded-full bg-yellow-400/20" />
                      </div>
                      <p className="text-xs  text-[#8B8FA8] mb-3">MASTERCARD</p>
                      <img className="w-10 my-3" src="https://app.encryptwallet.io/img/illustrations/card-chip.svg" alt="" />
                      <p className=" text-[#8B8FA8] text-sm tracking-widest my-2">
                        {cardData?.card_number ? `•••• •••• •••• ${String(cardData.card_number).slice(-4)}` : "•••• •••• •••• ••••"}
                      </p>
                      <div className="flex justify-between mt-3">
                        <div>
                          <p className="text-[10px] text-[#3D4160] uppercase tracking-widest">Card Holder</p>
                          <p className="text-xs  text-white">{cardData?.card_holder_name || "FULL NAME"}</p>
                        </div>
                        <div>
                          <p className="text-[10px] text-[#3D4160] uppercase tracking-widest">Expires</p>
                          <p className="text-xs  text-white">{cardData?.card_expiry_month || "MM"}/{cardData?.card_expiry_year?.slice(-2) || "YY"}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                ) : (
                  <div>
                    {/* Swift / BSB toggle */}
                    <div className="flex gap-2 mb-4">
                      {["swift", "bsb"].map(opt => (
                        <button key={opt} onClick={() => { setButtonManage(opt === "swift"); setAccountData({ ...accountData, bank: opt }); }}
                          className={`px-4 py-1.5 rounded-lg text-xs  font-bold border transition-all uppercase
                            ${(opt === "swift" ? buttonManage : !buttonManage) ? "bg-[#6C5DD3] border-[#6C5DD3] text-white" : "bg-[#080A12] border-[#2A2D3E] text-[#8B8FA8]"}`}>
                          {opt}
                        </button>
                      ))}
                    </div>
                    <form onKeyDown={e => e.key === "Enter" && handleAddPayment()}>
                      <Field label="Account Number">
                        <Input value={accountData?.account_number} onChange={e => setAccountData({ ...accountData, account_number: e.target.value })} className="w-full" size="large" placeholder="4324542415425" style={darkInputStyle} />
                      </Field>
                      <Field label="Account Holder Name">
                        <Input value={accountData?.acount_holder_name} onChange={e => setAccountData({ ...accountData, acount_holder_name: e.target.value })} size="large" placeholder="John Doe" style={darkInputStyle} />
                      </Field>
                      <Field label="Bank Name">
                        <Input value={accountData?.bank_name} onChange={e => setAccountData({ ...accountData, bank_name: e.target.value })} size="large" placeholder="Deutsche Bank" style={darkInputStyle} />
                      </Field>
                    </form>
                  </div>
                )}
              </div>
            )}

            {/* ══ VERIFICATION ══ */}
            {tabManage?.third && (
              <div>
                <div className="mb-3 border-b border-[#1E2030]">
                  <h2 className="text-base sm:text-lg font-bold text-white">{Accountverification || "Account Verification"}</h2>
                  <p className="text-xs text-[#8B8FA8] mt-0.5">Manage your account verification</p>
                </div>

                <div className="bg-[#080A12] border border-[#1E2030] rounded-xl p-4 sm:p-5">
                  <div className="flex flex-col gap-3">
                    {/* Top row: Avatar + Name/Email + Badge */}
                    <div className="flex items-center gap-3">
                      {/* Avatar */}
                      <div className="w-14 h-14 rounded-2xl overflow-hidden border-2 border-[#6C5DD3] shrink-0">
                        <img
                          src={data?.avatar_url ? data?.avatar_url : avatar1}
                          className="w-full h-full object-cover"
                          alt="avatar"
                        />
                      </div>

                      {/* Name + Email */}
                      <div className="flex flex-col min-w-0 flex-1">
                        <div className="flex flex-wrap items-center gap-2">
                          <p className="text-sm font-bold text-white leading-tight">{data?.name}</p>
                          {/* Badge inline with name */}
                          <div className="shrink-0">
                            {user?.active_status === "approved" ? (
                              <Badge status="approved" />
                            ) : user?.kyc_document_address ? (
                              <span className="inline-flex items-center gap-1 px-2.5 py-0.5 rounded-full text-xs font-semibold border bg-amber-500/10 text-amber-400 border-amber-500/30">
                                <span className="w-1.5 h-1.5 rounded-full bg-current" />
                                KYC Pending
                              </span>
                            ) : (
                              <span className="inline-flex items-center gap-1 px-2.5 py-0.5 rounded-full text-xs font-semibold border bg-[#1E2030] text-[#8B8FA8] border-[#2A2D3E]">
                                <span className="w-1.5 h-1.5 rounded-full bg-current" />
                                Unverified
                              </span>
                            )}
                          </div>
                        </div>
                        <p className="text-xs text-[#8B8FA8] truncate">{data?.email}</p>
                      </div>
                    </div>
                  </div>

                  {!user?.active_status !== "approved" && !user?.kyc_document_address && (
                    <div className="mt-4 pt-4 border-t border-[#1E2030] flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
                      <div>
                        <p className="text-xs font-semibold text-[#8B8FA8] uppercase tracking-widest">KYC Progress</p>
                        <p className="text-sm text-white mt-0.5">Waiting for approval</p>
                      </div>
                      <Link to="/verification" className="inline-flex items-center gap-2 px-4 py-2 bg-[#6C5DD3] hover:bg-[#7B6AE0] text-white text-sm font-semibold rounded-xl transition-all shadow-[0_0_16px_rgba(108,93,211,0.3)]">
                        Start Verification
                      </Link>
                    </div>
                  )}
                </div>
              </div>
            )}

            {/* ══ PASSWORD CHANGE ══ */}
            {tabManage?.fourth && (
              <div>
                <div className="flex flex-wrap gap-3 items-start justify-between mb-3 border-b border-[#1E2030]">
                  <div>
                    <h2 className="text-base sm:text-lg font-bold text-white">{change} {Password}</h2>
                    <p className="text-xs text-[#8B8FA8] mt-0.5">for {an} {improved} {account} {security}</p>
                  </div>
                  <div className="flex items-center gap-2">
                    <GlowBtn loading={loading?.password} onClick={handlePasswordUpdate}><AiFillSave size={14} /> <span className="hidden sm:inline">Save</span></GlowBtn>
                  </div>
                </div>

                <div className="max-w-md space-y-1">
                  <Field label={`${current} ${Password}`}>
                    <Input.Password prefix={<IoLockClosedOutline className="text-[#8B8FA8]" />} onChange={e => setPassword({ ...password, current_password: e.target.value })} placeholder="Enter current password" value={password?.current_password} size="large" style={darkInputStyle} />
                  </Field>
                  <Field label={`${New} ${Password}`}>
                    <Input.Password prefix={<IoLockClosedOutline className="text-[#8B8FA8]" />} onChange={e => setPassword({ ...password, new_password: e.target.value })} placeholder="Enter new password" value={password?.new_password} size="large" style={darkInputStyle} />
                  </Field>
                  <Field label={`${Repeat} ${New} ${Password}`}>
                    <Input.Password prefix={<IoLockClosedOutline className="text-[#8B8FA8]" />} onChange={e => setPassword({ ...password, repeat_password: e.target.value })} placeholder="Repeat new password" value={password?.repeat_password} size="large" style={darkInputStyle} />
                  </Field>
                </div>
              </div>
            )}

            {/* ══ LOGIN HISTORY ══ */}
            {tabManage?.fifth && (
              <div>
                <div className="mb-3 border-b border-[#1E2030]">
                  <h2 className="text-base sm:text-lg font-bold text-white">{Login} {history}</h2>
                </div>

                {/* Mobile: stacked cards */}
                <div className="md:hidden space-y-2">
                  {loginUser?.map((item, i) => (
                    <div key={i} className="bg-[#080A12] border border-[#1E2030] rounded-xl p-4 space-y-3">
                      <div className="flex items-center justify-between">
                        <p className="text-sm font-semibold text-white truncate pr-2">{item?.device || "Unknown device"}</p>
                        <span className={`inline-flex items-center gap-1 px-2.5 py-0.5 rounded-full text-xs font-semibold border ${item?.status === "active" ? "bg-sky-500/10 text-sky-400 border-sky-500/30" : "bg-[#1E2030] text-[#8B8FA8] border-[#2A2D3E]"}`}>
                          <span className="w-1.5 h-1.5 rounded-full bg-current" />{item?.status || "N/A"}
                        </span>
                      </div>
                      <div className="grid grid-cols-2 gap-x-4 gap-y-2 text-xs">
                        {[[browser, item?.browser], [location, item?.location], [platform, item?.platform], [`${ip} ${Address}`, item?.ip_address]].map(([lbl, val]) => (
                          <div key={lbl}>
                            <p className="text-[#3D4160] uppercase tracking-wider text-[10px] mb-0.5">{lbl}</p>
                            <p className="text-[#8B8FA8] truncate">{val || "N/A"}</p>
                          </div>
                        ))}
                      </div>
                      <div className="grid grid-cols-2 gap-x-4 text-xs pt-2 border-t border-[#1E2030]">
                        <div>
                          <p className="text-[#3D4160] uppercase tracking-wider text-[10px] mb-0.5">{login} {at}</p>
                          <p className="text-[#8B8FA8]">{item?.login_timestamp || "N/A"}</p>
                        </div>
                        <div>
                          <p className="text-[#3D4160] uppercase tracking-wider text-[10px] mb-0.5">{logout} {at}</p>
                          <p className="text-[#8B8FA8]">{item?.logout_timestamp || "N/A"}</p>
                        </div>
                      </div>
                    </div>
                  ))}
                  {(!loginUser || loginUser.length === 0) && (
                    <div className="text-center py-12 text-[#8B8FA8] text-sm">No login history found</div>
                  )}
                </div>

                {/* Tablet/Desktop: table */}
                <div className="hidden md:block overflow-x-auto rounded-xl border border-[#1E2030]">
                  <table className="w-full text-sm">
                    <thead>
                      <tr className="bg-[#080A12]">
                        {[device, browser, location, platform, `${ip} ${Address}`, `${login} ${at}`, `${logout} ${at}`, status].map(h => (
                          <th key={h} className="px-4 py-3 text-left text-xs font-bold text-[#8B8FA8] uppercase tracking-widest whitespace-nowrap border-b border-[#1E2030]">{h}</th>
                        ))}
                      </tr>
                    </thead>
                    <tbody className="divide-y divide-[#1E2030]">
                      {loginUser?.map((item, i) => (
                        <tr key={i} className="hover:bg-[#080A12]/60 transition-colors">
                          {[item?.device, item?.browser, item?.location, item?.platform, item?.ip_address, item?.login_timestamp, item?.logout_timestamp].map((val, j) => (
                            <td key={j} className="px-4 py-3 text-[#8B8FA8] text-xs whitespace-nowrap">{val || "N/A"}</td>
                          ))}
                          <td className="px-4 py-3">
                            <span className={`inline-flex items-center gap-1 px-2.5 py-0.5 rounded-full text-xs font-semibold border ${item?.status === "active" ? "bg-sky-500/10 text-sky-400 border-sky-500/30" : "bg-[#1E2030] text-[#8B8FA8] border-[#2A2D3E]"}`}>
                              <span className="w-1.5 h-1.5 rounded-full bg-current" />{item?.status || "N/A"}
                            </span>
                          </td>
                        </tr>
                      ))}
                      {(!loginUser || loginUser.length === 0) && (
                        <tr><td colSpan={8} className="text-center py-12 text-[#8B8FA8] text-xs">No login history found</td></tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            )}

          </main>
        </div>
      </div>
    </div>
  );
};

export default UserProfile;